import styled from 'styled-components';

import { StyledFormSectionHeader } from '../../common/StyledFormSectionHeader';

export const StyledPatientPhoneNotificationHeader = styled(StyledFormSectionHeader)`
   padding-bottom: 12px;
`;
StyledPatientPhoneNotificationHeader.displayName = 'StyledPatientPhoneNotificationHeader';
